export const PASSWORD_RECEIVE_SUCCESS = 'PASSWORD_RECEIVE_SUCCESS';
export const PASSWORD_RECEIVE_FAIL = 'PASSWORD_RECEIVE_FAIL';
export const PASSWORD_RECEIVE_INIT = 'PASSWORD_RECEIVE_INIT';
export const PASSWORD_TYPE_PASSWORD = 'PASSWORD_TYPE_PASSWORD';
export const PASSWORD_TYPE_TEXT = 'PASSWORD_TYPE_TEXT';

export const LOGIN_RECEIVE_SUCCESS = 'LOGIN_RECEIVE_SUCCESS';
export const LOGIN_RECEIVE_FAIL = 'LOGIN_RECEIVE_FAIL';
export const LOGIN_RECEIVE_INIT = 'LOGIN_RECEIVE_INIT';

export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_SUCCESS_LOAD = 'AUTH_SUCCESS_LOAD';
export const AUTH_EXIT = 'AUTH_EXIT';
export const AUTH_MOUNTED_SUCCESS = 'AUTH_MOUNTED_SUCCESS';
export const AUTH_ERROR_MESSAGE_INIT = 'AUTH_ERROR_MESSAGE_INIT';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';

// FIND USER
export const FETCH_FIND_USER_INIT = 'FETCH_FIND_USER_INIT';
export const FETCH_FIND_USER_PENDING = 'FETCH_FIND_USER_PENDING';
export const FETCH_FIND_USER_SUCCESS = 'FETCH_FIND_USER_SUCCESS';
export const FETCH_FIND_USER_FAIL = 'FETCH_FIND_USER_FAIL';
export const FETCH_FIND_USER_AUTH_ID = 'FETCH_FIND_USER_AUTH_ID';
export const FETCH_FIND_USER_EMAIL = 'FETCH_FIND_USER_EMAIL';
export const FETCH_FIND_USER_ENABLE_INPUTS = 'FETCH_FIND_USER_ENABLE_INPUTS';
export const FETCH_FIND_USER_ACTIVE_TAB = 'FETCH_FIND_USER_ACTIVE_TAB';
export const FETCH_FIND_USER_FAIL_WHILE_SEARCH_INIT = 'FETCH_FIND_USER_FAIL_WHILE_SEARCH_INIT';
export const AUTH_ID = 'auth_id';
export const EMAIL = 'Email';

// COMMENTS
export const FETCH_COMMENTS_INIT = 'FETCH_COMMENTS_INIT';
export const FETCH_COMMENTS_PENDING = 'FETCH_COMMENTS_PENDING';
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const FETCH_COMMENTS_FAIL = 'FETCH_COMMENTS_FAIL';
export const FETCH_COMMENTS_BAR_HIDE = 'FETCH_COMMENTS_BAR_HIDE';
export const FETCH_COMMENTS_BAR_SHOW = 'FETCH_COMMENTS_BAR_SHOW';
export const FETCH_COMMENTS_VALUE = 'FETCH_COMMENTS_VALUE';
export const FETCH_SEND_COMMENTS_PENDING = 'FETCH_SEND_COMMENTS_PENDING';
export const FETCH_SEND_COMMENTS_SUCCESS = 'FETCH_SEND_COMMENTS_SUCCESS';
export const FETCH_SEND_COMMENTS_FAIL = 'FETCH_SEND_COMMENTS_FAIL';

// DATEPICKERS
export const FETCH_DATEPICKERS_INIT = 'FETCH_DATEPICKERS_INIT';
export const FETCH_DATEPICKERS_START_DATE = 'FETCH_DATEPICKERS_START_DATE';
export const FETCH_DATEPICKERS_END_DATE = 'FETCH_DATEPICKERS_END_DATE';
export const FETCH_DATEPICKERS_PENDING = 'FETCH_DATEPICKERS_PENDING';
export const FETCH_DATEPICKERS_ERROR = 'FETCH_DATEPICKERS_ERROR';
export const FETCH_DATEPICKERS_HIDE = 'FETCH_DATEPICKERS_HIDE';
export const FETCH_DATEPICKERS_SHOW = 'FETCH_DATEPICKERS_SHOW';

// ACTIVITY
export const FETCH_ACTIVITY_INIT = 'FETCH_ACTIVITY_INIT';
export const FETCH_ACTIVITY_PENDING = 'FETCH_ACTIVITY_PENDING';
export const FETCH_ACTIVITY_ERROR = 'FETCH_ACTIVITY_ERROR';
export const FETCH_ACTIVITY_SUCCESS = 'FETCH_ACTIVITY_SUCCESS';
export const FETCH_ACTIVITY_YEAR = 'FETCH_ACTIVITY_YEAR';
export const FETCH_ACTIVITY_MONTH = 'FETCH_ACTIVITY_MONTH';
export const FETCH_ACTIVITY_CURRENT_DAY = 'FETCH_ACTIVITY_CURRENT_DAY';

// USER_EXPLORER
export const FETCH_USER_EXPLORER_INIT = 'FETCH_USER_EXPLORER_INIT';
export const FETCH_USER_EXPLORER_PENDING = 'FETCH_USER_EXPLORER_PENDING';
export const FETCH_USER_EXPLORER_ERROR = 'FETCH_USER_EXPLORER_ERROR';
export const FETCH_USER_EXPLORER_SUCCESS = 'FETCH_USER_EXPLORER_SUCCESS';
export const FETCH_USER_EXPLORER_CURRENT_EVENT = 'FETCH_USER_EXPLORER_CURRENT_EVENT';
export const FETCH_USER_EXPLORER_CHANGE_CATEGORY = 'FETCH_USER_EXPLORER_CHANGE_CATEGORY';

// COMMUNICATION
export const FETCH_COMMUNICATION_INIT = 'FETCH_COMMUNICATION_INIT';
export const FETCH_COMMUNICATION_PENDING = 'FETCH_COMMUNICATION_PENDING';
export const FETCH_COMMUNICATION_SUCCESS = 'FETCH_COMMUNICATION_SUCCESS';
export const FETCH_COMMUNICATION_FAIL = 'FETCH_COMMUNICATION_FAIL';

// PAYMENTS_INFO
export const FETCH_PAYMENTS_INIT = 'FETCH_PAYMENTS_INIT';
export const FETCH_PAYMENTS_PENDING = 'FETCH_PAYMENTS_PENDING';
export const FETCH_PAYMENTS_SUCCESS = 'FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_FAIL = 'FETCH_PAYMENTS_FAIL';

// MAP
export const FETCH_MAP_INIT = 'FETCH_MAP_INIT';
export const FETCH_MAP_PENDING = 'FETCH_MAP_PENDING';
export const FETCH_MAP_SUCCESS = 'FETCH_MAP_SUCCESS';
export const FETCH_MAP_FAIL = 'FETCH_MAP_FAIL';
export const FETCH_MAP_SHOW = 'FETCH_MAP_SHOW';
export const FETCH_MAP_HIDE = 'FETCH_MAP_HIDE';

export const PERSONAL_AVATAR = 'avatar';
export const PERSONAL_PREFERENCE = 'product_preference';
export const PERSONAL_RELATED_USERS = 'related_users';
export const PERSONAL_SAVED_AOI = 'current_saved_aoi';
export const PERSONAL_USER_ID = 'user_id';
export const PERSONAL_FIRST_NAME = 'first_name';
export const PERSONAL_LAST_NAME = 'last_name';
export const PERSONAL_EMAIL = 'email';
export const PERSONAL_COUNTRY = 'country';
export const PERSONAL_AREA = 'Field_area';

export const URL = 'url';
export const FETCH_FIND_USER_DISABLE_EMAIL = 'FETCH_FIND_USER_DISABLE_EMAIL';
export const FETCH_FIND_USER_DISABLE_ID = 'FETCH_FIND_USER_DISABLE_ID';

//PRODUCT
export const PRODUCT_INIT = 'PRODUCT_INIT';
export const PRODUCT_RECEIVE = 'PRODUCT_RECEIVE';

export const PERSONAL_ACTIVE_TAB = 0;
export const ACTIVITY_ACTIVE_TAB = 1;
export const COMMUNICATION_ACTIVE_TAB = 2;
export const PAYMENTS_ACTIVE_TAB = 3;

export const PRODUCT_LAND_VIEWER = 0;
export const PRODUCT_AGRO = 1;

export const MAP_KEY = 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA';

export const EMPTY_FIELD = '';

export const FETCH_MAP_FIELD_LIST_INIT = 'FETCH_MAP_FIELD_LIST_INIT';
export const FETCH_MAP_FIELD_LIST_PENDING = 'FETCH_MAP_FIELD_LIST_PENDING';
export const FETCH_MAP_FIELD_LIST_SUCCESS = 'FETCH_MAP_FIELD_LIST_SUCCESS';
export const FETCH_MAP_FIELD_LIST_ERROR = 'FETCH_MAP_FIELD_LIST_ERROR';
export const FETCH_MAP_FIELD_LIST_ORDER = 'FETCH_MAP_FIELD_LIST_ORDER';

export const FETCH_MAP_FIELD_INIT = 'FETCH_MAP_FIELD_INIT';
export const FETCH_MAP_FIELD_PENDING = 'FETCH_MAP_FIELD_PENDING';
export const FETCH_MAP_FIELD_SUCCESS = 'FETCH_MAP_FIELD_SUCCESS';
export const FETCH_MAP_FIELD_ERROR = 'FETCH_MAP_FIELD_ERROR';
export const FETCH_MAP_FIELD_USER_ID = 'FETCH_MAP_FIELD_USER_ID';
export const CURRENT_MAP_FIELD_ID = 'CURRENT_MAP_FIELD_ID';
export const SET_CURRENT_SNAP_TILE = 'SET_CURRENT_SNAP_TILE';
export const SET_CURRENT_DRAW_LAYER = 'SET_CURRENT_DRAW_LAYER';
export const SET_CURRENT_CENTER = 'SET_CURRENT_CENTER';

export const FETCH_MAP_FIELD = 'FETCH_MAP_FIELD';

export const DEFAULT_MAP_STYLE = 'mapbox://styles/mapbox/satellite-streets-v10';

export enum ApplicationTab {
  User = 0,
  Activity = 1,
  Communication = 2,
  Payments = 3,
}

export enum SubscriptionPeriod {
  ANNUAL = 'year',
  MONTHLY = 'month',
}